// Angular + External
import { NgModule } from "@angular/core";
import { RouterModule, Routes, RouterOutlet } from "@angular/router";

import { OmsPlatformOrders } from "./oms-platform-orders/oms-platform-orders";
import { AuthGuard } from "./bfx-common/guards/auth-guard.service";
import { PrimeGuard } from "./bfx-common/guards/prime-guard.service";
import { SSOLoginComponent } from "./bfx-auth/sso-login.component";

const appRoutes: Routes = [
  {
    path: "main",
    component: OmsPlatformOrders,
    canActivate: [AuthGuard, PrimeGuard],
  },
  { path: "", redirectTo: "login", pathMatch: "full" },
  { path: "sso/saml/main", component: SSOLoginComponent },
  { path: "saml2/", component: SSOLoginComponent },
  { path: "**", redirectTo: "not-found", pathMatch: "full" },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],

  exports: [RouterModule, RouterOutlet],
})
export class AppRoutingModule {}
